import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ISelectedProfile, UserState } from './user.types';

// Initial state occurring when user is not initialized yet
// All fields should be NULL when not logged in yet.
export const initialState: UserState = {
  loginDate: undefined,
  selectedProfile: null,
  sourceApp: null,
};

/**
 * The slice   reducer for the part of state that represents the logged in user.
 * Contains the management of user information.
 */
const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    resetSelectedProfile: (state) => {
      state.selectedProfile = null;
    },
    resetUserState(state) {
      Object.assign(state, initialState);
    },
    setLoginDate: (state, action: PayloadAction<number | undefined>) => {
      state.loginDate = action.payload;
    },
    setSelectedProfile: (state, action: PayloadAction<ISelectedProfile>) => {
      state.selectedProfile = action.payload;
    },
    setSourceApp: (state, action: PayloadAction<string>) => {
      state.sourceApp = action.payload.toUpperCase();
    },
  },
});

export const { actions: userAction } = userSlice;

export default userSlice.reducer;
